// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '2e7a4663-652c-4b40-879c-518ea1861ad8',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e0128fc5-40a3-4de7-a51b-d52069ba0c90',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2e7a4663-652c-4b40-879c-518ea1861ad8'
    },
    {
      id: '2b07fc4d-cd1b-4b46-be22-38874f337095',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2e7a4663-652c-4b40-879c-518ea1861ad8'
    },
    {
      id: '77322409-c664-4b50-bb58-090bbc0d4f8e',
      type: 'Container',
      name: 'contentSlot',
      className: '',
      x: 0,
      y: 254,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2e7a4663-652c-4b40-879c-518ea1861ad8'
    },
    {
      id: '770d8138-3212-4ef4-98cd-0c08230ac149',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 30.04,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'e0128fc5-40a3-4de7-a51b-d52069ba0c90',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '9f36d416-ad84-44e2-9ee9-7540b14c5ca6',
      type: 'Sprite',
      name: 'backgroundGradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'e0128fc5-40a3-4de7-a51b-d52069ba0c90',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '3900b62d-577a-4ca3-93de-52dc9eb71968',
      type: 'Sprite',
      name: 'backgroundBlur',
      className: '',
      x: 0,
      y: 620,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 6,
        y: 5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Background_Blurred_Image',
      parent: 'e0128fc5-40a3-4de7-a51b-d52069ba0c90',
      stateByName: {
        help: {
          alpha: 0.5
        }
      }
    },
    {
      id: 'f86dba7e-4c9a-40c3-9cec-a489063a4104',
      type: 'Sprite',
      name: 'backgroundImage',
      className: '',
      x: 0,
      y: -31,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Image',
      parent: '2b07fc4d-cd1b-4b46-be22-38874f337095'
    },
    {
      id: '48335617-b0ad-4f6d-bbaa-cff0207890ad',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 330,
      y: 68,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Close_Button',
      parent: '2b07fc4d-cd1b-4b46-be22-38874f337095',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        help: {
          alpha: 0
        }
      }
    },
    {
      id: '3d79174e-3077-48df-8f57-cefb4d9db201',
      type: 'Sprite',
      name: 'helpButton',
      className: '',
      x: -330,
      y: 68,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help_Button',
      parent: '2b07fc4d-cd1b-4b46-be22-38874f337095',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        help: {
          alpha: 0
        }
      }
    },
    {
      id: '19ef3e8f-a52d-4eb0-a4ec-014f0fca5ab7',
      type: 'Text',
      name: 'title',
      className: '',
      x: 0,
      y: 185,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Treasure Pass',
      localize: true,
      maxWidth: 639,
      maxHeight: 128,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#270349',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#270349',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2b07fc4d-cd1b-4b46-be22-38874f337095'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'help'
  ],
  animations: [
    {
      id: 'ed43c351-49c7-45af-bdc1-0c5ef1c09928',
      name: 'trackToHelpTransition',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '0c43fbe1-8f3a-488e-912a-31de55982cd3',
          type: 'Tween',
          name: 'helpButtonFadeOut',
          duration: 300,
          track: 1,
          target: {
            anchor: {},
            alpha: 0
          },
          startAt: 0,
          sourceName: 'helpButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'c979c847-0b84-40a0-9618-5bb9d8915a72',
          type: 'Tween',
          name: 'imageMove',
          duration: 300,
          track: 4,
          target: {
            y: -31,
            scale: {}
          },
          startAt: 0,
          sourceName: 'backgroundImage',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'c5ab964f-227a-4b96-8ddf-ab407b1b4af5',
          type: 'Tween',
          name: 'closeButtonFadeOut',
          duration: 300,
          track: 2,
          target: {
            anchor: {},
            alpha: 0
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '4c90a54a-cb25-45fa-88ec-872baae97fd2',
          type: 'Tween',
          name: 'blurFadeOut',
          duration: 300,
          track: 3,
          target: {
            alpha: 0.5
          },
          startAt: 0,
          sourceName: 'backgroundBlur',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'b11729db-e54b-42ea-b7b1-051749811503',
      name: 'helpToTrackTransition',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '89568710-d6f6-4cb5-bd47-01fc1bcb75dd',
          type: 'Tween',
          name: 'closeButtonFadeIn',
          duration: 300,
          track: 4,
          target: {
            anchor: {},
            alpha: 1
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '432655cf-3438-4aae-baa9-5e188fba7cac',
          type: 'Tween',
          name: 'helpButtonFadeIn',
          duration: 300,
          track: 1,
          target: {
            anchor: {},
            alpha: 1
          },
          startAt: 0,
          sourceName: 'helpButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'f7168e60-bd9f-4e9f-89ff-1f6b99f55806',
          type: 'Tween',
          name: 'blurFadeIn',
          duration: 300,
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'backgroundBlur',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassPopupLayout {
  static raw = raw;
  root!: Container;
  header!: Container;
  contentSlot!: Container;
  backgroundGradient!: Sprite & { data: typeof raw['list'][5]['data'] };
  backgroundBlur!: Sprite;
  backgroundImage!: Sprite;
  closeButton!: Sprite & { data: typeof raw['list'][8]['data'] };
  helpButton!: Sprite & { data: typeof raw['list'][9]['data'] };
  title!: Text;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][4]['data'] } | Sprite & { data: typeof raw['list'][5]['data'] })[];
  StateName!: 'help';

  constructor() {
    populate(this, raw);
  }
}

export abstract class trackToHelpTransition {
  Layout: {
    helpButton: object;
    backgroundImage: object;
    closeButton: object;
    backgroundBlur: object;
  };

  BlockTypeByName: {
    helpButtonFadeOut: object;
    imageMove: object;
    closeButtonFadeOut: object;
    blurFadeOut: object;
  };

  flowData = raw.animations[0];
}

export abstract class helpToTrackTransition {
  Layout: {
    closeButton: object;
    helpButton: object;
    backgroundBlur: object;
  };

  BlockTypeByName: {
    closeButtonFadeIn: object;
    helpButtonFadeIn: object;
    blurFadeIn: object;
  };

  flowData = raw.animations[1];
}
